import React, { useEffect, useState } from "react";
import { Button, Divider, Image, Input, Link } from "@nextui-org/react";
import Google from "../../Images/Google.jsx";
import { EyeSlashFilledIcon } from "../../Images/EyeSlashFilledIcon";
import { EyeFilledIcon } from "../../Images/EyeFilledIcon";
import {
  getAlldata,
  getAllRoles,
  sendCreateAccountOTP,
} from "../../controllers/APIController.js";
import { NavigateSign } from "../../controllers/loginController.js";
import { useNavigate, useLocation } from "react-router-dom";
import Loading from "../../components/Loader/Loading.jsx";
import { GoogleAuth } from "../../controllers/social.js";
import CryptoJS from "crypto-js";
import {
  encryptedText,
  generateOtp,
  decryptedText,
} from "../../utils/helper.js";
import toast, { Toaster } from "react-hot-toast";

const Signup = () => {
  const navigate = useNavigate();

  const handleGoogleAuth = async (e) => {
    e.stopPropagation();
    const data = await GoogleAuth();
    window.location.href = data.urlWithQueryParams;
  };

  const handlePasswordlessAuth = async (e) => {
    e.stopPropagation();
    navigate("/passwordless-sign");
  };

  const [isVisible, setIsVisible] = React.useState(false);
  const [Users, setUsers] = useState(null);
  const [ValidationConditions, setValidationConditions] = useState(false);

  const [Loader, setLoader] = useState(false);
  const EmailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  const PassWordRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

  const Location = useLocation();
  const [LoginDetails, setLoginDetails] = useState({
    name: "",
    email: "",
    password: "",
  });

  const [LoginError, setLoginError] = useState({
    emailError: "",
    passwordError: "",
    FinalError: "",
  });

  const navigate_forgot = () => {
    navigate("/auth/reset-password");
  };

  // Handler functions for form inputs
  const handleNameChange = (e) => {
    setLoginDetails({ ...LoginDetails, name: e.target.value });
  };

  const handleEmailChange = (e) => {
    setLoginDetails({ ...LoginDetails, email: e.target.value });
  };

  const handlePasswordChange = (e) => {
    setLoginDetails({ ...LoginDetails, password: e.target.value });
  };

  const togglePasswordVisibility = () => {
    setIsVisible(!isVisible);
  };

  const EmailExist =
    Users &&
    Users?.filter(
      (data) => data?.email === LoginDetails.email?.toLowerCase()?.trim()
    );

  const generateRandomNumber = () => {
    return Math.floor(Math.random() * 100) + 1;
  };

  const [randomNumber, setRandomNumber] = useState(generateRandomNumber());

  const secretKey = "";

  const encryptData = (data) => {
    return CryptoJS.AES.encrypt(data, secretKey).toString();
  };

  const Validation = () => {
    let IsValid = true;

    if (LoginDetails.email === "") {
      IsValid = false;
      setLoginError((previous) => ({
        ...previous,
        emailError: "Email is required.",
      }));
    } else if (!EmailRegex.test(LoginDetails.email)) {
      IsValid = false;
      setLoginError((previous) => ({
        ...previous,
        emailError: "Enter valid email format.",
      }));
    } else if (EmailExist && EmailExist.length > 0) {
      IsValid = false;
      setLoginError((previous) => ({
        ...previous,
        emailError: "Email already exists, log in to your account",
      }));
    } else {
      setLoginError((previous) => ({ ...previous, emailError: "" }));
    }

    if (LoginDetails.password === "") {
      IsValid = false;
      setLoginError((previous) => ({
        ...previous,
        passwordError: "Password is required.",
      }));
    } else if (
      !PassWordRegex.test(LoginDetails.password) ||
      LoginDetails?.password?.trim()?.length < 8 ||
      LoginDetails?.password?.trim()?.length > 16
    ) {
      IsValid = false;
      setLoginError((previous) => ({
        ...previous,
        passwordError:
          "Password should contain lower-case, upper-case, digit, Special Character ,have minimum length 8 and maximum length 16.",
      }));
    } else {
      setLoginError((previous) => ({ ...previous, passwordError: null }));
    }

    return IsValid;
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      SubmitHandler();
    }
  };

  const SubmitHandler = async () => {
    setLoader(true);
    const Validate = Validation();

    if (Validate) {
      try {
        setValidationConditions(false);
        const otpString = generateOtp();
        const limit = Date.now() + 5 * 60 * 1000;

        const encryptOtp = encryptedText(otpString);
        const encryptedEmail = encryptedText(LoginDetails.email?.trim());
        const encryptedPassword = encryptedText(LoginDetails.password?.trim());

        const encryptedLimit = encryptedText(limit.toString());
        const url = `${process.env.REACT_APP_IP_ADDRESS}/auth/verify-otp?email=${encryptedEmail}&limit=${encryptedLimit}&password=${encryptedPassword}`;

        const res = await sendCreateAccountOTP({
          to: LoginDetails.email?.trim(),
          url,
          otp: otpString,
        });

        localStorage.setItem("user-otp", encryptOtp);

        toast.success(
          "Email sent successfully, Check your email to verify the OTP!"
        );

        navigate(
          `/auth/verify-otp?email=${encryptedEmail}&limit=${encryptedLimit}&password=${encryptedPassword}`
        );

        setLoader(false);
      } catch (error) {
        console.log(error);
      }
    } else {
      setValidationConditions(true);
      setLoader(false);
    }
  };

  useEffect(() => {
    getAlldata("users")
      .then((data) => setUsers(data))
      .catch((error) => console.log(error));

    getAllRoles();
  }, []);

  const toggleVisibility = () => setIsVisible(!isVisible);


  return (
    <>
      <Toaster position="bottom-right" reverseOrder={true} />
      {Loader ? (
        <div
          className={`absolute z-[100]  inset-0 h-screen w-screen  bg-slate-50'`}
        >
          <Loading />
        </div>
      ) : (
        ""
      )}

      <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4 text-sm">
        {/* Content */}
        <div className="w-full max-w-md">
            {/* Form Container */}
            <div className="bg-white rounded-lg border border-gray-200 p-8">
              {/* Logo and Header */}
              <div className="text-center mb-8">
                <div className="flex justify-center mb-6">
                  <Image width={48} alt="Audyt Logo" src="Assets/logo.svg" />
                </div>
                <h1 className="text-2xl font-bold text-gray-900 mb-2">
                  Create your account
                </h1>
                <p className="text-gray-600 text-sm">
                  Get started with your free account
                </p>
              </div>

              {/* Error Message */}
              {/* The 'error' variable is not defined in this component, so this block will be removed. */}
              {/* {error && (
                <div className="mb-6 p-4 bg-red-50 border border-red-200 rounded-lg shadow-sm">
                  <p className="text-red-700 text-xs font-medium">
                    {error}
                  </p>
                </div>
              )} */}

              {/* Main Sign Up Form */}
              <form data-gtm-form-interact-id="0" onKeyDown={handleKeyPress} className="space-y-6 mb-6">
                {/* Name Input */}
                <div>
                  <Input
                    radius="md"
                    variant="bordered"
                    type="text"
                    label="Full Name"
                    placeholder="Enter your full name"
                    value={LoginDetails.name}
                    onChange={handleNameChange}
                    labelPlacement="outside"
                    classNames={{
                      label: "text-gray-700 font-medium text-sm",
                      input: "text-gray-900 text-sm",
                      inputWrapper: "bg-white border-gray-300 hover:border-emerald-400 focus-within:border-emerald-500 transition-all duration-200 h-10",
                    }}
                  />
                </div>

                {/* Email Input */}
                <div>
                  <Input
                    radius="md"
                    variant="bordered"
                    type="email"
                    label="Email"
                    placeholder="Enter your email"
                    value={LoginDetails.email}
                    onChange={handleEmailChange}
                    labelPlacement="outside"
                    classNames={{
                      label: "text-gray-700 font-medium text-sm",
                      input: "text-gray-900 text-sm",
                      inputWrapper: "bg-white border-gray-300 hover:border-emerald-400 focus-within:border-emerald-500 transition-all duration-200 h-10",
                    }}
                  />
                </div>

                {/* Password Input */}
                <div>
                  <Input
                    radius="md"
                    variant="bordered"
                    type={isVisible ? "text" : "password"}
                    label="Password"
                    placeholder="Create a password"
                    value={LoginDetails.password}
                    onChange={handlePasswordChange}
                    labelPlacement="outside"
                    endContent={
                      <button
                        type="button"
                        onClick={togglePasswordVisibility}
                        className="focus:outline-none"
                      >
                        {isVisible ? (
                          <EyeSlashFilledIcon className="text-lg text-gray-400 hover:text-gray-600 transition-colors" />
                        ) : (
                          <EyeFilledIcon className="text-lg text-gray-400 hover:text-gray-600 transition-colors" />
                        )}
                      </button>
                    }
                    classNames={{
                      label: "text-gray-700 font-medium text-sm",
                      input: "text-gray-900 text-sm",
                      inputWrapper: "bg-white border-gray-300 hover:border-emerald-400 focus-within:border-emerald-500 transition-all duration-200 h-10",
                    }}
                  />
                </div>

                {/* Password Requirements */}
                <div className="p-3 bg-gray-50 rounded-lg border border-gray-200">
                  <p className="text-xs text-gray-600 font-medium mb-2">Password requirements:</p>
                  <ul className="text-xs text-gray-500 space-y-1">
                    <li className="flex items-center gap-2">
                      <i className="fas fa-check text-emerald-500 text-xs"></i>
                      At least 8 characters
                    </li>
                    <li className="flex items-center gap-2">
                      <i className="fas fa-check text-emerald-500 text-xs"></i>
                      One uppercase letter
                    </li>
                    <li className="flex items-center gap-2">
                      <i className="fas fa-check text-emerald-500 text-xs"></i>
                      One number
                    </li>
                  </ul>
                </div>

                {/* Sign Up Button */}
                <Button
                  id="CreateAccount"
                  radius="md"
                  onClick={SubmitHandler}
                  className="w-full h-10 bg-emerald-600 text-white font-semibold hover:bg-emerald-700 transition-all duration-200 text-sm"
                  size="sm"
                >
                  Create Account
                  <lord-icon
                    src="https://cdn.lordicon.com/vduvxizq.json"
                    trigger="hover"
                    target="#CreateAccount"
                    
                    style={{
                      width: "16px",
                      height: "16px",
                    }}
                  />
                </Button>
              </form>

              {/* Divider */}
              <div className="relative mb-6">
                <div className="absolute inset-0 flex items-center">
                  <div className="w-full border-t border-gray-200"></div>
                </div>
                <div className="relative flex justify-center text-sm">
                  <span className="px-4 bg-white text-gray-500 font-medium">or</span>
                </div>
              </div>

              {/* Alternative Sign Up Options */}
              <div className="space-y-3 mb-6">
                <Button
                  radius="md"
                  variant="bordered"
                  onClick={handleGoogleAuth}
                  className="w-full h-10 bg-white border-gray-300 hover:border-gray-400 transition-all duration-200 text-sm font-medium text-gray-700"
                  size="sm"
                >
                  <Image width={16} alt="Google" src="Images/Google.webp" className="mr-3" />
                  Continue with Google
                </Button>

                <Button
                  radius="md"
                  variant="bordered"
                  onClick={() => navigate("/passwordless-sign")}
                  className="w-full h-10 bg-white border-gray-300 hover:border-gray-400 transition-all duration-200 text-sm font-medium text-gray-700"
                  size="sm"
                >
                  <lord-icon
                    src="https://cdn.lordicon.com/yxczfiyc.json"
                    trigger="hover"
                    
                    style={{
                      width: "16px",
                      height: "16px",
                    }}
                  />
                  Sign up Passwordless
                </Button>
              </div>

              {/* Sign In Link */}
              <div className="text-center mb-6">
                <span className="text-gray-600 text-sm">
                  Already have an account?{" "}
                  <button
                    onClick={() => navigate("/sign-in")}
                    className="text-emerald-600 hover:text-emerald-700 font-semibold transition-colors"
                  >
                    Sign in here
                  </button>
                </span>
              </div>

              {/* Terms */}
              <div className="pt-4 border-t border-gray-100">
                <p className="text-xs text-gray-500 text-center leading-relaxed">
                  By creating an account, you agree to our{" "}
                  <Link href="#" size="sm" className="text-emerald-600 hover:text-emerald-700">
                    Terms of Service
                  </Link>{" "}
                  and{" "}
                  <Link href="#" size="sm" className="text-emerald-600 hover:text-emerald-700">
                    Privacy Policy
                  </Link>
                  .
                </p>
              </div>
            </div>
          </div>
        </div>
      </>
  );
};

export default Signup;
